var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuData_warp"},[_c('el-menu',{attrs:{"collapse-transition":"","default-active":_vm.activeMenu,"background-color":"rgb(27, 61, 109)","text-color":"#fff","active-text-color":"#ffffff"},on:{"select":_vm.handleSelect,"open":_vm.handleOpen}},[_c('menu-tree',{attrs:{"menuData":_vm.menuList}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec9cad18","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/landmark-user/components/menuData.vue
// module id = null
// module chunks = 